// types
import { IEnergyOverview } from './types'
// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { useStyletron } from 'baseui';
//import { SmallPanel } from './SmallPanel';
import { IoMdFlash } from 'react-icons/io';
import { Suspense } from 'react';
import React from 'react';
import { themedUseStyletron } from '../../../theme/customTheme';


const SmallPanel = React.lazy(() =>
    import('./SmallPanel')
        .then(({ SmallPanel }) => ({ default: SmallPanel })),
);

export function OverviewPanel(props: IEnergyOverview) {
    const [css,theme] = themedUseStyletron();

    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight} icon={<IoMdFlash size="100%"></IoMdFlash>} {...props}>
            <Suspense fallback={<div>Loading...</div>}>
                <SmallPanel showChart {...props}></SmallPanel>
            </Suspense>

        </OverviewPanelWrapper>
    );
}